import React, { useEffect, useState } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import EndpointFilters from "./EndpointFilters";
import EndpointBoxes from "./EndpointBoxes";
import EndpointGraph from "./EndpointGraph";
import EndpointTable from "./EndpointTable";
import UnauthorizedPage from "../UnauthorizedPage";

const apiUrl = process.env.REACT_APP_API_URL;

export default function Endpoint() {
  const [graphData, setGraphData] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [boxData, setBoxData] = useState(null);
const [oem, setOem] = useState(localStorage.getItem('oem') || "all");
const [product, setProduct] = useState(localStorage.getItem('product') || "all");
const [environment, setEnvironment] = useState(localStorage.getItem('environment') || "all");
const [apiType, setApiType] = useState(localStorage.getItem('apiType') || "all");
  const [duration, setDuration] =  useState(localStorage.getItem('duration') || "7days");
  const [permissions, sethandlePermissions] = useState(true);
  const [error, setError] = useState(null);
  let accessToken = useSelector((state) => state.accessToken.value);
  const query = `query MyQuery($duration:String!, $apiType:String!, $environment:String!, $oemName:String!, $productName:String!) {
    getMainEndpointPageDetails(duration: $duration, filters: {ApiType: $apiType, Environment: $environment, OemName: $oemName, ProductName: $productName}) {
      graphresultsArray {
        averagePerDayData {
          avgAvailability
          timeInterval
        }
        endpointName
      }
      overallResults {
        endpoint
        availabilityPercentage
        downRequests
        latestTimestamp
        latestStatus
      }
      overallAvailability
    }
  }`;

  const variables = {
    duration,
    environment,
    oemName: oem,
    productName: product,
    apiType,
  };

  const getData = async () => {
    try {
      setBoxData(null);
      setGraphData([]);
      setTableData([]);
      const response = await axios.post(
        apiUrl,
        { query, variables },
        {
          headers: {
            Authorization: accessToken,
          },
        }
      );
      if (response.data.data && response.data.data.getMainEndpointPageDetails) {
        const graphResults =
          response.data.data.getMainEndpointPageDetails.graphresultsArray;
        const tableResults =
          response.data.data.getMainEndpointPageDetails.overallResults;
        const overallAvailability =
          response.data.data.getMainEndpointPageDetails.overallAvailability;

        const runningEndpoints = tableResults.filter(
          (item) => item.latestStatus === "Running"
        ).length;
        const failedEndpoints = tableResults.filter(
          (item) => item.latestStatus === "Stopped"
        ).length;

        setGraphData(graphResults);
        setTableData(tableResults);
        setBoxData({ runningEndpoints, failedEndpoints, overallAvailability });
      }

      if (
        response.data.errors &&
        response.data.errors[0].errorType == "Unauthorized"
      ) {
        setError("Unauthorized");
      }
    } catch (error) {
      sethandlePermissions(false);
      return;
    }
  };

  useEffect(() => {
    getData();
  }, [oem, product, duration, environment, apiType]);
  if (error == "Unauthorized") {
    return <UnauthorizedPage />;
  }
  return (
    <div className="p-4 space-y-6">
      <EndpointFilters
        setOem={setOem}
        setApiType={setApiType}
        setDuration={setDuration}
        setEnvironment={setEnvironment}
        setProduct={setProduct}
        oem={oem}
        product={product}
        environment={environment}
        apiType={apiType}
        duration={duration}
        error= {error}
        setError={setError}
      />
      <EndpointBoxes data={boxData} />
      <EndpointGraph data={graphData} duration={duration} />
      <EndpointTable data={tableData} />
    </div>
  );
}
